import React from 'react';
import { TermsPanel } from '../components/workspace/TermsPanel';
import { ArrowLeft } from 'lucide-react';
import { WorkiumLogo } from '../components/brand/WorkiumLogo';
export function TermsPage() {
  return <div className="min-h-screen bg-slate-950" data-id="element-7135">
      {/* Minimal public header */}
      <header className="sticky top-0 z-50 bg-slate-950/80 backdrop-blur-lg border-b border-slate-800" data-id="element-7136">
        <div className="max-w-4xl mx-auto px-4 lg:px-8 h-16 flex items-center justify-between" data-id="element-7137">
          <div className="flex items-center gap-6" data-id="element-7138">
            <a href="/" className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-900 border border-slate-800 text-slate-400 hover:text-slate-200 hover:bg-slate-800 transition-all" title="Volver al inicio" data-id="element-7139">
              <ArrowLeft size={16} data-id="element-7140" />
            </a>
            <WorkiumLogo size="sm" data-id="element-7141" />
          </div>
          <a href="/privacy" className="text-sm text-indigo-400 hover:text-indigo-300 transition-colors" data-id="element-7142">
            Política de Privacidad
          </a>
        </div>
      </header>
      <TermsPanel data-id="element-7143" />
    </div>;
}